import React from "react";
import PropTypes from "prop-types";
import { StoreProvider } from "../../store/assistantStore";
import Assistant from "./Assistant";
import { EventBus, EventBusProvider } from "../../utils/useEventBus";

const AssistantProvider = ({ eventBus, ...props }) => {
  return (
    <EventBusProvider eventBus={eventBus}>
      <StoreProvider>
        <Assistant {...props} />
      </StoreProvider>
    </EventBusProvider>
  );
};

AssistantProvider.propTypes = {
  assistant: PropTypes.object,
  eventBus: PropTypes.object
};
AssistantProvider.displayName = "AssistantProvider";
export default AssistantProvider;
